import { useClassContext } from '../../../../../class/Context';
import { useCourseContext } from '../../../../../course/Context';

const usePollIdentifier = () => {
  const { course } = useCourseContext();
  const { cls } = useClassContext();
  return { course, cls };
};

export default usePollIdentifier;
